import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AlertService } from '@core/services/alert.service';
import { TenantSessionService } from '@core/services/tenant-session.service';

export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const alertService = inject(AlertService);
  const tenantSessionService = inject(TenantSessionService);

  const isAdmin = (tenantSessionService.getCurrentUser()?.rolesObject ?? []).some((role) => {
    const key = String(role?.role_key ?? role?.catalogRoleObject?.role_key ?? '')
      .trim()
      .toUpperCase();
    return key === 'ADMIN';
  });

  if (isAdmin) {
    return true;
  }

  alertService.open({
    type: 'warning',
    message: 'No tienes acceso a esta sección con tu rol actual.',
  });

  return router.createUrlTree(['/']);
};
